import type { IconSvgObject } from './types';

const ListXIcon: IconSvgObject = [
  ["path", { d: "M3 5H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 12H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.0083 9.50391L18.5 11.9997M18.5 11.9997L21 14.5039M18.5 11.9997L16 14.5039M18.5 11.9997L20.9917 9.50391", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 19H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ListXIcon;
